import axiosInstance from './axiosConfig';

export const uploadProfileImageFile = async (file) => {
  const formData = new FormData();
  formData.append('profileImage', file);

  const response = await axiosInstance.post('/api/auth/profile-image', formData);

  if (!response.data.success) {
    throw new Error(response.data.message || 'Could not upload image');
  }

  return response.data.data.user;
};
